import { ArrayLayoutProps, composePaths } from "@jsonforms/core";
import { UISchemaElement } from "@jsonforms/core/src/models/uischema";
import {
  JsonFormsDispatch,
  withJsonFormsArrayLayoutProps,
} from "@jsonforms/react";
import { Box } from "@mui/material";

const ArrayCommonRenderer = ({
  schema,
  uischema,
  data,
  path,
  renderers,
  cells,
}: ArrayLayoutProps) => {
  const toRender = Array(data)
    .fill(0)
    .map((_, i) => {
      const newPath = composePaths(path, `${i}`);
      return (
        <Box className="array-layout" key={newPath}>
          {uischema?.options?.detail?.elements?.map(
            (childUiSchema: UISchemaElement | undefined, j: number) => {
              const key = `${newPath}-${j}`;
              return (
                <JsonFormsDispatch
                  key={key}
                  uischema={childUiSchema}
                  schema={schema}
                  path={newPath}
                  renderers={renderers}
                  cells={cells}
                />
              );
            },
          )}
        </Box>
      );
    });
  return <>{toRender}</>;
};

export default withJsonFormsArrayLayoutProps(ArrayCommonRenderer);
